import React from "react";
import {
  FiFileText,
  FiBookOpen,
  FiUsers,
  FiArrowRight,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function SaasProducts() {
  const navigate = useNavigate();

  const products = [
    {
      icon: <FiFileText />,
      title: "MapleDoc",
      subtitle:
        "Enterprise Document Management Platform for Secure Digital Workflows",
      desc: "Improve document control, accessibility, compliance, and workflow efficiency across teams.",
    },
    {
      icon: <FiBookOpen />,
      title: "MapleLearn",
      subtitle:
        "Learning Management Platform for Workforce Enablement",
      desc: "Support training delivery, learning workflows, and scalable knowledge programs.",
    },
    {
      icon: <FiUsers />,
      title: "MCTHRMS",
      subtitle:
        "Human Resource Management Platform",
      desc: "Streamline workforce records, HR workflows, and employee operations.",
    },
  ];

  return (
    <div className="w-full home-goal py-24 px-8 md:px-16">
      
      {/* Heading */}
      <div className="text-center mb-16">
        <p className="text-cyan-400 uppercase tracking-[3px] text-sm font-semibold mb-4">
          SaaS Products
        </p>

        <h2 className="text-white text-4xl md:text-5xl font-semibold">
          SaaS Products for Business Operations
        </h2>

        <p className="text-gray-400 mt-5 max-w-3xl mx-auto text-lg">
          Cloud-ready business platforms for document workflows,
          learning management, and workforce operations.
        </p>
      </div>

      {/* Product Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((item, index) => (
          <div
            key={index}
            className="group backdrop-blur-md bg-blue/20 border border-cyan-500/20 rounded-3xl p-8 hover:-translate-y-3 transition duration-300 hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]"
          >
            {/* Icon */}
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 flex items-center justify-center mb-6">
              <div className="text-cyan-400 text-2xl">
                {item.icon}
              </div>
            </div>

            {/* Title */}
            <h3 className="text-white text-2xl font-semibold mb-4">
              {item.title}
            </h3>

            {/* Subtitle */}
            <h4 className="text-cyan-100 text-lg font-medium mb-4 leading-snug">
              {item.subtitle}
            </h4>

            {/* Description */}
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              {item.desc}
            </p>

            {/* CTA */}
            <button className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 font-medium text-sm">
              Learn More <FiArrowRight />
            </button>
          </div>
        ))}
      </div>

      {/* Bottom CTA */}
      <div className="flex justify-center mt-14">
        <button
          onClick={() => navigate("/productpage")}
          className="bg-cyan-600 hover:bg-cyan-500 text-white px-8 py-4 rounded-full font-semibold transition duration-300 shadow-lg shadow-cyan-500/20"
        >
          Explore SaaS Products
        </button>
      </div>
    </div>
  );
}

export default SaasProducts;